import { render } from "./member-list.vue?vue&type=template&id=84bcc616"
import script from "./member-list.vue?vue&type=script&lang=js"
export * from "./member-list.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__